import { FC, useCallback } from 'react';

import { Button, Icon } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { spacesActions } from 'src/store/spaces/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface CreateSpaceButtonProps {
  className?: string;
}

export const CreateSpaceButton: FC<CreateSpaceButtonProps> = ({
  className,
}) => {
  const dispatch = useAppDispatch();

  const create = useCallback(() => {
    dispatch(spacesActions.openSpace(null));
  }, [dispatch]);

  return (
    <Button
      variant='contained'
      onClick={create}
      data-testid='createSpace'
      startIcon={<Icon iconName={Icons.Add} />}
      className={className}
    >
      Создать пространство
    </Button>
  );
};
